export enum BillingCycleType {
	BiWeekly = 0,
	Monthly = 1,
}
